import React from "react";
import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import SectionWrapper from "../../components/SectionWrapper/SectionWrapper";

const PromotionRuleComposerPage: React.FC = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <SectionWrapper>
        <div className="p-6">
          <h2 className="text-xl font-semibold mb-4">Composición de Reglas</h2>
          <p>Combina múltiples reglas de descuento dentro de una promoción.</p>
        </div>
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default PromotionRuleComposerPage;
